import { Getter } from '@if/core/utils'

export const lazyLoad = <T>(getter: Getter<T>): (() => T) => {
  let value: T | undefined
  return () => {
    if (!value) {
      value = getter()
    }
    return value
  }
}
